
// YouTube thumbnails: templates ask for maxresdefault (16:9, no bars); videos without a
// high-res still return a 120px placeholder or 404, so fall back to hqdefault (MANE-798).
document.addEventListener('error', function(event) {
	var img = event.target;
	if (!img || img.tagName !== 'IMG' || !/img\.youtube\.com\/vi\/[^/]+\/maxresdefault\.jpg/.test(img.src)) return;
	img.src = img.src.replace('/maxresdefault.jpg', '/hqdefault.jpg');
}, true);
document.addEventListener('load', function(event) {
	var img = event.target;
	if (!img || img.tagName !== 'IMG' || !/maxresdefault\.jpg/.test(img.src)) return;
	if (img.naturalWidth && img.naturalWidth <= 120) img.src = img.src.replace('/maxresdefault.jpg', '/hqdefault.jpg');
}, true);
// Main application JS
import '../css/app.css';
import '../css/site.css';

function setCookie(name, value, days) {
	var maxAge = days * 24 * 60 * 60;
	document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax';
}

// ─── HEADER + SITE ALERT INTERACTION ──────────────
// The header is fixed-positioned. The alert lives at the top of normal flow.
// As the page scrolls, slide the header up by `(alertHeight - scrollY)`
// (clamped to 0) so the alert appears to scroll off and the header pins.
// Also: toggle .scrolled on the header so transparent variants go solid.

var header = null;
var siteAlert = null;
var siteAlertStorageKey = null;

function getAlertHeight() {
	if (!siteAlert) return 0;
	if (siteAlert.hidden) return 0;
	if (!document.contains(siteAlert)) return 0;
	return siteAlert.offsetHeight || 0;
}

function syncSiteAlertOffset() {
	var stickyHeight = (siteAlert && siteAlert.dataset.siteAlertSticky === 'true') ? getAlertHeight() : 0;
	document.documentElement.style.setProperty('--site-alert-offset', stickyHeight + 'px');
}

function updateHeaderPosition() {
	if (!header) return;
	var alertH = getAlertHeight();
	var scrolled = window.scrollY || window.pageYOffset || 0;
	var offset = Math.max(0, alertH - scrolled);
	header.style.top = offset + 'px';
	if (scrolled > 10) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
}

function dismissSiteAlert() {
	if (!siteAlert) return;
	siteAlert.hidden = true;
	syncSiteAlertOffset();
	updateHeaderPosition();
	if (!siteAlertStorageKey) return;
	try {
		window.localStorage.setItem(siteAlertStorageKey, 'dismissed');
	} catch (e) { /* ignore */ }
}

function initializeSiteAlert() {
	siteAlert = document.querySelector('[data-site-alert]');
	if (!siteAlert) {
		syncSiteAlertOffset();
		return;
	}

	siteAlertStorageKey = siteAlert.dataset.siteAlertKey
		? 'bayou-site-alert:' + siteAlert.dataset.siteAlertKey
		: null;

	if (siteAlertStorageKey) {
		try {
			if (window.localStorage.getItem(siteAlertStorageKey) === 'dismissed') {
				siteAlert.hidden = true;
			}
		} catch (e) { /* ignore */ }
	}

	var dismissBtn = siteAlert.querySelector('[data-site-alert-dismiss]');
	if (dismissBtn) {
		dismissBtn.addEventListener('click', dismissSiteAlert);
	}

	syncSiteAlertOffset();
}

function initializeHeaderScroll() {
	header = document.getElementById('globalHeader');
	if (!header) return;
	if (header.dataset.transparentHeader === 'true') {
		document.body.classList.add('has-transparent-header');
	}
	window.addEventListener('scroll', updateHeaderPosition, { passive: true });
	window.addEventListener('resize', function() {
		syncSiteAlertOffset();
		updateHeaderPosition();
	}, { passive: true });
	updateHeaderPosition();
}

// ─── MOBILE MENU ──────────────────────────────────
function initializeMobileMenu() {
	var overlay = document.querySelector('[data-mobile-menu]');
	if (!overlay) return;

	var openBtns = document.querySelectorAll('[data-mobile-menu-open]');
	var closeBtns = overlay.querySelectorAll('[data-mobile-menu-close]');

	function open() {
		overlay.classList.add('open');
		document.body.style.overflow = 'hidden';
	}
	function close() {
		overlay.classList.remove('open');
		document.body.style.overflow = '';
	}

	for (var i = 0; i < openBtns.length; i++) {
		openBtns[i].addEventListener('click', open);
	}
	for (var j = 0; j < closeBtns.length; j++) {
		closeBtns[j].addEventListener('click', close);
	}
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && overlay.classList.contains('open')) {
			close();
		}
	});
	// Close after navigating to in-page links
	overlay.querySelectorAll('a[href^="/"], a[href^="#"]').forEach(function(link) {
		link.addEventListener('click', close);
	});
}

// ─── DESKTOP HEADER SEARCH ────────────────────────
function initializeHeaderSearch() {
	var headerEl = document.getElementById('globalHeader');
	if (!headerEl) return;

	var openBtn = headerEl.querySelector('[data-header-search-open]');
	var overlay = headerEl.querySelector('[data-header-search]');
	if (!openBtn || !overlay) return;

	var input = overlay.querySelector('.header-search-field');
	var closeBtn = overlay.querySelector('[data-header-search-close]');
	var form = overlay.querySelector('form');

	function isOpen() {
		return headerEl.classList.contains('header--searching');
	}

	function open() {
		overlay.hidden = false;
		// Unhide first, then flip the class on the next frame so the
		// fade/slide transitions actually run.
		window.requestAnimationFrame(function() {
			headerEl.classList.add('header--searching');
		});
		openBtn.setAttribute('aria-expanded', 'true');
		window.setTimeout(function() {
			if (input) input.focus();
		}, 80);
	}

	function close() {
		headerEl.classList.remove('header--searching');
		openBtn.setAttribute('aria-expanded', 'false');
		if (input) input.blur();
		window.setTimeout(function() {
			if (!isOpen()) overlay.hidden = true;
		}, 280);
	}

	openBtn.addEventListener('click', function() {
		if (isOpen()) {
			close();
		} else {
			open();
		}
	});

	if (closeBtn) {
		closeBtn.addEventListener('click', close);
	}

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && isOpen()) {
			close();
			openBtn.focus();
		}
	});

	// Don't submit an empty query — keep focus in the field instead.
	if (form) {
		form.addEventListener('submit', function(e) {
			if (!input || !input.value.trim()) {
				e.preventDefault();
				if (input) input.focus();
			}
		});
	}
}

// ─── STAFF GRID FILTER ────────────────────────────
function initializeStaffGrid() {
	var grids = document.querySelectorAll('[data-staff-grid]');
	if (!grids.length) return;

	grids.forEach(function(grid) {
		var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-staff-card]'));
		var buttons = Array.prototype.slice.call(grid.querySelectorAll('[data-staff-filter]'));
		var empty = grid.querySelector('[data-staff-empty]');
		if (!cards.length || !buttons.length) return;

		function apply(filter) {
			var visible = 0;
			cards.forEach(function(card) {
				var match = filter === 'all' ||
					(card.getAttribute('data-staff-category') || '') === filter;
				card.hidden = !match;
				card.classList.toggle('is-hidden', !match);
				if (match) visible++;
			});
			buttons.forEach(function(button) {
				var isActive = (button.getAttribute('data-staff-filter') || 'all') === filter;
				button.classList.toggle('active', isActive);
				button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});
			if (empty) empty.hidden = visible !== 0;
		}

		buttons.forEach(function(button) {
			button.addEventListener('click', function() {
				apply(button.getAttribute('data-staff-filter') || 'all');
			});
		});

		apply('all');
	});
}

var photoCollageSections = [];
var photoCollageRows = [];
var photoCollageResizeFrame = null;
var photoCollageMotionQuery = null;

function resetPhotoCollageRow(row) {
	var track = row.querySelector('[data-photo-collage-track]');
	if (!track) return;

	track.querySelectorAll('[data-photo-collage-clone]').forEach(function(clone) {
		clone.remove();
	});

	row.dataset.photoCollageReady = 'false';
	row.style.removeProperty('--photo-collage-shift');
	row.style.removeProperty('--photo-collage-duration');
}

function setupPhotoCollageRow(row) {
	var track = row.querySelector('[data-photo-collage-track]');
	var sequence = track ? track.querySelector('[data-photo-collage-sequence]:not([data-photo-collage-clone])') : null;
	if (!track || !sequence) return;

	resetPhotoCollageRow(row);

	if (photoCollageMotionQuery && photoCollageMotionQuery.matches) {
		return;
	}

	var containerWidth = row.clientWidth || 0;
	var sequenceWidth = Math.ceil(sequence.getBoundingClientRect().width);
	if (!containerWidth || !sequenceWidth) return;

	var trackStyles = window.getComputedStyle(track);
	var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
	var sequenceSpan = sequenceWidth + gap;
	var requiredSequences = Math.max(2, Math.ceil(containerWidth / sequenceSpan) + 2);

	for (var index = 1; index < requiredSequences; index++) {
		var clone = sequence.cloneNode(true);
		clone.dataset.photoCollageClone = 'true';
		clone.setAttribute('aria-hidden', 'true');
		track.appendChild(clone);
	}

	row.style.setProperty('--photo-collage-shift', sequenceSpan + 'px');
	row.style.setProperty('--photo-collage-duration', Math.max(18, Math.round(sequenceSpan / 28)) + 's');
	row.dataset.photoCollageReady = 'true';
}

function refreshPhotoCollages() {
	for (var i = 0; i < photoCollageRows.length; i++) {
		setupPhotoCollageRow(photoCollageRows[i]);
	}
}

function initializePhotoCollages() {
	photoCollageSections = document.querySelectorAll('[data-photo-collage]');
	photoCollageRows = [];
	if (!photoCollageSections.length) return;

	for (var sectionIndex = 0; sectionIndex < photoCollageSections.length; sectionIndex++) {
		var rows = photoCollageSections[sectionIndex].querySelectorAll('[data-photo-collage-row]');
		for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
			photoCollageRows.push(rows[rowIndex]);
		}
	}

	if (!photoCollageRows.length) return;

	photoCollageMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	refreshPhotoCollages();

	window.addEventListener('load', refreshPhotoCollages);
	window.addEventListener('resize', function() {
		if (photoCollageResizeFrame) {
			window.cancelAnimationFrame(photoCollageResizeFrame);
		}

		photoCollageResizeFrame = window.requestAnimationFrame(function() {
			refreshPhotoCollages();
			photoCollageResizeFrame = null;
		});
	}, { passive: true });

	if (photoCollageMotionQuery && typeof photoCollageMotionQuery.addEventListener === 'function') {
		photoCollageMotionQuery.addEventListener('change', refreshPhotoCollages);
	}
}

function initializeResourcesMenus() {
	var menus = document.querySelectorAll('[data-resources-menu]');
	if (!menus.length) return;

	function closeMenu(menu) {
		var trigger = menu.querySelector('[data-resources-trigger]');
		var panel = menu.querySelector('[data-resources-panel]');
		if (!trigger || !panel) return;
		panel.hidden = true;
		trigger.setAttribute('aria-expanded', 'false');
	}

	function closeAll(exceptMenu) {
		menus.forEach(function(menu) {
			if (menu !== exceptMenu) closeMenu(menu);
		});
	}

	menus.forEach(function(menu) {
		var trigger = menu.querySelector('[data-resources-trigger]');
		var panel = menu.querySelector('[data-resources-panel]');
		if (!trigger || !panel) return;

		trigger.addEventListener('click', function(e) {
			e.stopPropagation();
			var isOpen = trigger.getAttribute('aria-expanded') === 'true';
			closeAll(menu);
			panel.hidden = isOpen;
			trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
		});
	});

	document.addEventListener('click', function(e) {
		menus.forEach(function(menu) {
			if (!menu.contains(e.target)) closeMenu(menu);
		});
	});

	document.addEventListener('keydown', function(e) {
		if (e.key !== 'Escape') return;
		menus.forEach(closeMenu);
	});
}

function initializeMinistriesScrollers() {
	var scrollers = document.querySelectorAll('[data-ministries-scroller]');
	if (!scrollers.length) return;

	scrollers.forEach(function(scroller) {
		var track = scroller.querySelector('[data-ministries-track]');
		var prev = scroller.querySelector('[data-ministries-prev]');
		var next = scroller.querySelector('[data-ministries-next]');
		if (!track) return;

		function tileStep() {
			var tile = track.querySelector('.ministry-tile');
			if (!tile) return 320;
			return tile.getBoundingClientRect().width + 22;
		}

		function update() {
			if (prev) prev.hidden = track.scrollLeft <= 4;
			if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
		}

		if (prev) {
			prev.addEventListener('click', function() {
				track.scrollBy({ left: -tileStep(), behavior: 'smooth' });
			});
		}

		if (next) {
			next.addEventListener('click', function() {
				track.scrollBy({ left: tileStep(), behavior: 'smooth' });
			});
		}

		track.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update, { passive: true });
		update();
	});
}

/**
 * Generic horizontal pager for cardGrid/scrollRow blocks rendered in
 * scroll mode. Pager buttons are present in DOM but stay hidden until
 * the track is wider than its viewport. Step size is one full card
 * width (incl. gap) so each click shifts a single card into view.
 * Keyboard support: Left/Right arrows when the scroller has focus.
 */
function initializeCardScrollers() {
	var scrollers = document.querySelectorAll('[data-card-scroller]');
	if (!scrollers.length) return;

	scrollers.forEach(function(scroller) {
		var track = scroller.querySelector('[data-card-scroller-track]');
		var prev = scroller.querySelector('[data-card-scroller-prev]');
		var next = scroller.querySelector('[data-card-scroller-next]');
		if (!track) return;

		function cardStep() {
			var card = track.firstElementChild;
			if (!card) return 280;
			var styles = window.getComputedStyle(track);
			var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
			return card.getBoundingClientRect().width + gap;
		}

		function update() {
			var overflows = track.scrollWidth - track.clientWidth > 4;
			if (overflows) {
				scroller.setAttribute('data-card-scroller-overflow', '');
			} else {
				scroller.removeAttribute('data-card-scroller-overflow');
			}
			if (prev) prev.hidden = !overflows || track.scrollLeft <= 4;
			if (next) next.hidden = !overflows || (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
		}

		if (prev) {
			prev.addEventListener('click', function() {
				track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
			});
		}
		if (next) {
			next.addEventListener('click', function() {
				track.scrollBy({ left: cardStep(), behavior: 'smooth' });
			});
		}

		track.tabIndex = track.tabIndex === -1 ? 0 : track.tabIndex;
		track.addEventListener('keydown', function(e) {
			if (e.key === 'ArrowRight') {
				e.preventDefault();
				track.scrollBy({ left: cardStep(), behavior: 'smooth' });
			} else if (e.key === 'ArrowLeft') {
				e.preventDefault();
				track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
			}
		});

		track.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update, { passive: true });

		if (typeof ResizeObserver !== 'undefined') {
			var ro = new ResizeObserver(update);
			ro.observe(track);
		}

		update();
	});
}

function initializeResourceSeriesAccordions() {
	var accordions = document.querySelectorAll('[data-resource-series-accordion]');
	if (!accordions.length) return;

	accordions.forEach(function(accordion) {
		var triggers = accordion.querySelectorAll('[data-resource-series-trigger]');
		triggers.forEach(function(trigger) {
			trigger.addEventListener('click', function() {
				var item = trigger.closest('.resource-series-item');
				if (!item) return;
				var isOpen = item.classList.toggle('open');
				trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			});
		});

		// Deep links (/resources#resource-group-by-design) open the targeted
		// series group and bring it into view; sermon "Resources" buttons use them.
		function openHashTarget() {
			var hash = window.location.hash ? window.location.hash.slice(1) : '';
			if (!hash) return;
			var target = document.getElementById(hash);
			if (!target || !accordion.contains(target) || !target.classList.contains('resource-series-item')) return;
			var trigger = target.querySelector('[data-resource-series-trigger]');
			target.classList.add('open');
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
			window.requestAnimationFrame(function() {
				target.scrollIntoView({ block: 'start', behavior: 'smooth' });
			});
		}
		openHashTarget();
		window.addEventListener('hashchange', openHashTarget);
	});
}

function initializeEpisodeAccordions() {
	var accordions = document.querySelectorAll('[data-episode-accordion]');
	if (!accordions.length) return;

	accordions.forEach(function(accordion) {
		var triggers = accordion.querySelectorAll('[data-episode-trigger]');
		if (!triggers.length) return;

		function setExpanded(item, trigger, isOpen) {
			item.classList.toggle('active', isOpen);
			trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		}

		triggers.forEach(function(trigger) {
			trigger.addEventListener('click', function() {
				var item = trigger.closest('.episode-item');
				if (!item) return;

				var wasOpen = item.classList.contains('active');
				triggers.forEach(function(otherTrigger) {
					var otherItem = otherTrigger.closest('.episode-item');
					if (otherItem) setExpanded(otherItem, otherTrigger, false);
				});

				if (!wasOpen) {
					setExpanded(item, trigger, true);
					var episodeUrl = trigger.getAttribute('data-episode-url');
					if (episodeUrl && window.history && window.history.pushState) {
						window.history.pushState(null, '', episodeUrl);
					}
				} else {
					var seriesUrl = accordion.getAttribute('data-series-url');
					if (seriesUrl && window.history && window.history.pushState) {
						window.history.pushState(null, '', seriesUrl);
					}
				}
			});
		});
	});
}

function youtubeStartSeconds(url) {
	var m = url.match(/[?&#](?:start|t)=([^&#]+)/);
	if (!m) return 0;
	var v = decodeURIComponent(m[1]);
	if (/^\d+s?$/.test(v)) return parseInt(v, 10);
	var parts = v.match(/(\d+)h|(\d+)m|(\d+)s/g);
	if (!parts) return 0;
	return parts.reduce(function(total, part) {
		var n = parseInt(part, 10);
		return total + (part.slice(-1) === 'h' ? n * 3600 : part.slice(-1) === 'm' ? n * 60 : n);
	}, 0);
}

function resourceVideoEmbedUrl(url) {
	if (!url) return '';
	// Playlist URLs must keep their list param (a bare /embed/videoseries id is
	// dead without it); a v= id alongside list= starts the playlist from there.
	var playlistMatch = url.match(/[?&]list=([^?&]+)/);
	if (playlistMatch && /youtube\.com|youtu\.be/.test(url)) {
		var playlistVideoMatch = url.match(/[?&]v=([^?&]+)/) || url.match(/youtu\.be\/([^?&]+)/);
		var playlistVideoId = playlistVideoMatch && playlistVideoMatch[1] !== 'videoseries' ? playlistVideoMatch[1] : 'videoseries';
		return 'https://www.youtube.com/embed/' + playlistVideoId + '?list=' + playlistMatch[1] + '&autoplay=1&rel=0';
	}
	var youtubeMatch = url.match(/youtu\.be\/([^?&#]+)/) ||
		url.match(/youtube\.com\/live\/([^?&#]+)/) ||
		url.match(/youtube\.com\/embed\/([^?&#]+)/) ||
		url.match(/youtube\.com\/shorts\/([^?&#]+)/) ||
		url.match(/[?&]v=([^?&#]+)/);
	if (youtubeMatch && youtubeMatch[1]) {
		// Honor a start offset (?start=1728, ?t=1728, ?t=28m48s): older sermons point at the
		// full-service recording and rely on it to jump to the message (MANE-813).
		var startSeconds = youtubeStartSeconds(url);
		return 'https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=1&rel=0' + (startSeconds ? '&start=' + startSeconds : '');
	}

	var vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
	if (vimeoMatch && vimeoMatch[1]) {
		return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
	}

	return url;
}

function initializeSermonSharing() {
	var shareButtons = document.querySelectorAll('[data-sermon-share]');
	if (!shareButtons.length) return;

	function absoluteUrl(value) {
		if (!value) return window.location.href;
		try {
			return new URL(value, window.location.origin).href;
		} catch (error) {
			return window.location.href;
		}
	}

	function shareDetails(button) {
		var activeSermon = document.querySelector('.episode-item.active[data-sermon-share-title]');
		var source = activeSermon || button;
		return {
			title: source.getAttribute(activeSermon ? 'data-sermon-share-title' : 'data-share-title') || document.title,
			text: source.getAttribute(activeSermon ? 'data-sermon-share-text' : 'data-share-text') || '',
			url: absoluteUrl(source.getAttribute(activeSermon ? 'data-sermon-share-url' : 'data-share-url')),
			image: source.getAttribute(activeSermon ? 'data-sermon-share-image' : 'data-share-image') || ''
		};
	}

	function copyText(value) {
		if (navigator.clipboard && window.isSecureContext) {
			return navigator.clipboard.writeText(value);
		}

		return new Promise(function(resolve, reject) {
			var textarea = document.createElement('textarea');
			textarea.value = value;
			textarea.setAttribute('readonly', '');
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				if (!document.execCommand('copy')) throw new Error('Copy command failed');
				resolve();
			} catch (error) {
				reject(error);
			} finally {
				document.body.removeChild(textarea);
			}
		});
	}

	function showButtonStatus(button, label) {
		var defaultLabel = button.getAttribute('data-share-default-label') || button.textContent.trim();
		button.setAttribute('data-share-default-label', defaultLabel);
		button.textContent = label;
		window.clearTimeout(button._shareResetTimer);
		button._shareResetTimer = window.setTimeout(function() {
			button.textContent = defaultLabel;
		}, 2400);
	}

	async function shareImageFile(imageUrl) {
		if (!imageUrl || typeof window.fetch !== 'function' || typeof window.File !== 'function') return null;
		var response = await window.fetch(absoluteUrl(imageUrl));
		if (!response.ok) throw new Error('Unable to load share image');
		var blob = await response.blob();
		var imagePath = new URL(absoluteUrl(imageUrl)).pathname;
		var filename = imagePath.split('/').pop() || 'sermon-image.jpg';
		return new File([blob], filename, { type: blob.type || 'image/jpeg' });
	}

	shareButtons.forEach(function(button) {
		button.addEventListener('click', async function(event) {
			event.preventDefault();
			var details = shareDetails(button);
			var baseShareText = [details.title, details.text, details.url].filter(Boolean).join('\n\n');
			var fullImageUrl = details.image ? absoluteUrl(details.image) : '';
			var textWithImageFallback = [baseShareText, fullImageUrl].filter(Boolean).join('\n\n');
			var isAndroid = /Android/i.test(navigator.userAgent);
			var isDesktop = !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
			var isMacOS = (navigator.platform || '').toUpperCase().indexOf('MAC') >= 0;
			var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
			var copyValue = fullImageUrl ? textWithImageFallback : baseShareText;

			if (navigator.share) {
				try {
					if (fullImageUrl && isAndroid) {
						// Android's share targets handle a text payload with the image URL
						// more reliably than a shared File object.
						await navigator.share({ text: textWithImageFallback });
						return;
					}

					if (fullImageUrl) {
						var imageFile = await shareImageFile(fullImageUrl);
						var imageShareData = imageFile ? {
							text: isDesktop && isMacOS && isChrome ? textWithImageFallback : baseShareText,
							files: [imageFile]
						} : null;

						if (imageShareData && navigator.canShare && navigator.canShare(imageShareData)) {
							try {
								await navigator.share(imageShareData);
								return;
							} catch (error) {
								if (error.name === 'AbortError') return;
							}
						}

						await navigator.share({ text: textWithImageFallback });
						return;
					}

					await navigator.share({ text: baseShareText });
					return;
				} catch (error) {
					if (error.name === 'AbortError') return;
				}
			}

			try {
				await copyText(copyValue);
				showButtonStatus(button, 'Copied');
			} catch (error) {
				showButtonStatus(button, 'Copy failed');
			}
		});
	});
}

function initializeResourceVideoModal() {
	var triggers = document.querySelectorAll('[data-resource-video-open]');
	if (!triggers.length) return;

	var modal = document.createElement('div');
	modal.className = 'video-modal resource-video-modal';
	modal.hidden = true;
	modal.innerHTML = [
		'<div class="video-modal-backdrop" data-resource-video-close></div>',
		'<div class="video-modal-content">',
		'<button class="video-modal-close" type="button" aria-label="Close" data-resource-video-close>&times;</button>',
		'<div class="video-modal-player">',
		'<iframe title="Video resource" src="about:blank" class="video-modal-media" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>',
		'</div>',
		'<div class="video-modal-info">',
		'<h3 data-resource-video-title></h3>',
		'<p class="text-light text-sm" data-resource-video-description></p>',
		'</div>',
		'</div>'
	].join('');
	document.body.appendChild(modal);

	var frame = modal.querySelector('iframe');
	var title = modal.querySelector('[data-resource-video-title]');
	var description = modal.querySelector('[data-resource-video-description]');
	var previousBodyOverflow = '';

	function openModal(trigger) {
		var url = trigger.getAttribute('data-video-url') || '';
		var src = resourceVideoEmbedUrl(url);
		if (!src || !frame) return;

		var videoTitle = trigger.getAttribute('data-video-title') || 'Video resource';
		var videoDescription = trigger.getAttribute('data-video-description') || '';
		frame.setAttribute('title', videoTitle);
		frame.setAttribute('src', src);
		if (title) title.textContent = videoTitle;
		if (description) {
			description.textContent = videoDescription;
			description.hidden = !videoDescription;
		}

		previousBodyOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		modal.hidden = false;
	}

	function closeModal() {
		modal.hidden = true;
		if (frame) frame.setAttribute('src', 'about:blank');
		document.body.style.overflow = previousBodyOverflow;
	}

	triggers.forEach(function(trigger) {
		trigger.addEventListener('click', function(event) {
			event.preventDefault();
			openModal(trigger);
		});
	});

	modal.querySelectorAll('[data-resource-video-close]').forEach(function(closeButton) {
		closeButton.addEventListener('click', closeModal);
	});

	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && !modal.hidden) {
			closeModal();
		}
	});
}

function initializeSharePage() {
	var buttons = document.querySelectorAll('[data-share-page]');
	if (!buttons.length) return;
	buttons.forEach(function(button) {
		button.addEventListener('click', function() {
			// Optional data-share-url lets one page offer several share targets (outline vs sermon, MANE-695).
			var shareUrl = button.getAttribute('data-share-url');
			if (shareUrl && !/^https?:/i.test(shareUrl)) shareUrl = window.location.origin + shareUrl;
			var payload = {
				title: button.getAttribute('data-share-title') || document.title,
				url: shareUrl || window.location.href
			};
			if (navigator.share) {
				navigator.share(payload).catch(function() {});
				return;
			}
			var copyText = payload.url;
			var done = function() {
				var original = button.textContent;
				button.textContent = 'Link copied';
				setTimeout(function() { button.textContent = original; }, 2000);
			};
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(copyText).then(done, function() {});
			} else {
				window.prompt('Copy this link:', copyText);
			}
		});
	});
}

function initializeResourceContentModal() {
	var triggers = document.querySelectorAll('[data-resource-content-open]');
	if (!triggers.length) return;

	var modal = document.createElement('div');
	modal.className = 'video-modal resource-content-modal';
	modal.hidden = true;
	modal.innerHTML = [
		'<div class="video-modal-backdrop" data-resource-content-close></div>',
		'<div class="video-modal-content" role="dialog" aria-modal="true">',
		'<button class="video-modal-close" type="button" aria-label="Close" data-resource-content-close>&times;</button>',
		'<div class="video-modal-info resource-content-modal-info">',
		'<div class="resource-content-modal-body" data-resource-content-body></div>',
		'</div>',
		'</div>'
	].join('');
	document.body.appendChild(modal);

	var content = modal.querySelector('.video-modal-content');
	var body = modal.querySelector('[data-resource-content-body]');
	var lockedScrollY = 0;

	function openModal(trigger) {
		var contentTitle = trigger.getAttribute('data-content-title') || 'Resource';
		var contentBody = trigger.getAttribute('data-content-body') || '';
		if (!contentBody || !body) return;

		if (content) content.setAttribute('aria-label', contentTitle);
		body.innerHTML = contentBody;

		// iOS ignores body overflow:hidden; pinning the body keeps the page put.
		lockedScrollY = window.scrollY || 0;
		document.body.style.position = 'fixed';
		document.body.style.top = -lockedScrollY + 'px';
		document.body.style.width = '100%';
		modal.hidden = false;
		if (content) content.scrollTop = 0;
	}

	function closeModal() {
		modal.hidden = true;
		if (body) body.innerHTML = '';
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';
		window.scrollTo(0, lockedScrollY);
	}

	triggers.forEach(function(trigger) {
		trigger.addEventListener('click', function(event) {
			event.preventDefault();
			openModal(trigger);
		});
	});

	modal.querySelectorAll('[data-resource-content-close]').forEach(function(closeButton) {
		closeButton.addEventListener('click', closeModal);
	});

	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && !modal.hidden) {
			closeModal();
		}
	});
}

function initializeStoriesArchives() {
	var archives = document.querySelectorAll('[data-stories-archive]');
	if (!archives.length) return;

	archives.forEach(function(archive) {
		var cards = Array.prototype.slice.call(archive.querySelectorAll('[data-story-card]'));
		var filterButtons = Array.prototype.slice.call(archive.querySelectorAll('[data-story-filter]'));
		var loadMore = archive.querySelector('[data-stories-load-more]');
		var count = archive.querySelector('[data-stories-count]');
		var empty = archive.querySelector('[data-stories-empty]');
		var initialLimit = parseInt(archive.getAttribute('data-initial-limit'), 10) || 9;
		var pageSize = parseInt(archive.getAttribute('data-page-size'), 10) || initialLimit;
		var activeFilter = 'all';
		var visibleLimit = initialLimit;

		// Deep-linked site search sends visitors here as /stories?q=term —
		// pre-filter the cards to the ones whose text matches that query.
		var searchQuery = '';
		if (window.URLSearchParams) {
			try {
				searchQuery = (new URLSearchParams(window.location.search).get('q') || '').trim().toLowerCase();
			} catch (error) {
				searchQuery = '';
			}
		}
		if (searchQuery) {
			// A q-based visit shows all matching categories, capped generously.
			visibleLimit = cards.length;
		}

		function setVisible(element, isVisible) {
			element.hidden = !isVisible;
			element.classList.toggle('is-hidden', !isVisible);
		}

		function matchesFilter(card) {
			if (searchQuery && (card.textContent || '').toLowerCase().indexOf(searchQuery) === -1) {
				return false;
			}
			if (activeFilter === 'all') return true;
			return (card.getAttribute('data-story-category') || '').toLowerCase() === activeFilter;
		}

		function render() {
			var matched = cards.filter(matchesFilter);
			var visibleCount = Math.min(visibleLimit, matched.length);

			cards.forEach(function(card) {
				setVisible(card, false);
			});

			matched.forEach(function(card, index) {
				setVisible(card, index < visibleLimit);
			});

			if (count) {
				count.textContent = matched.length
					? 'Showing ' + visibleCount + ' of ' + matched.length
					: 'Showing 0 of 0';
			}

			if (empty) {
				setVisible(empty, matched.length === 0);
			}

			if (loadMore) {
				setVisible(loadMore, visibleCount < matched.length);
			}
		}

		filterButtons.forEach(function(button) {
			button.addEventListener('click', function() {
				activeFilter = (button.getAttribute('data-story-filter') || 'all').toLowerCase();
				visibleLimit = initialLimit;

				filterButtons.forEach(function(otherButton) {
					var isActive = otherButton === button;
					otherButton.classList.toggle('active', isActive);
					otherButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
				});

				render();
			});
		});

		if (loadMore) {
			loadMore.addEventListener('click', function() {
				visibleLimit += pageSize;
				render();
			});
		}

		render();
	});
}

function initializeSermonSeriesArchives() {
	var archives = document.querySelectorAll('[data-sermon-series-archive]');
	if (!archives.length) return;

	archives.forEach(function(archive) {
		var cards = Array.prototype.slice.call(archive.querySelectorAll('[data-sermon-series-card]'));
		var loadMore = archive.querySelector('[data-sermon-series-load-more]');
		var count = archive.querySelector('[data-sermon-series-count]');
		var initialLimit = parseInt(archive.getAttribute('data-initial-limit'), 10) || 12;
		var pageSize = parseInt(archive.getAttribute('data-page-size'), 10) || initialLimit;
		var visibleLimit = initialLimit;

		function render() {
			var visibleCount = Math.min(visibleLimit, cards.length);

			cards.forEach(function(card, index) {
				card.hidden = index >= visibleLimit;
			});

			if (count) {
				count.textContent = 'Showing ' + visibleCount + ' of ' + cards.length;
			}

			if (loadMore) {
				loadMore.hidden = visibleCount >= cards.length;
			}
		}

		if (loadMore) {
			loadMore.addEventListener('click', function() {
				visibleLimit += pageSize;
				render();
			});
		}

		render();
	});
}

function initializeEventsArchives() {
	var archives = document.querySelectorAll('[data-events-archive]');
	if (!archives.length) return;

	function normalizeEventCategoryFilter(value) {
		var normalized = (value || '').toString().trim().toLowerCase();
		if (!normalized || normalized === 'all') return 'all';

		normalized = normalized
			.replace(/['’]/g, '')
			.replace(/&/g, 'and')
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '');

		var aliases = {
			mens: 'men',
			womens: 'women',
			kid: 'kids',
			childrens: 'kids',
			student: 'students',
			preschoolers: 'preschool'
		};

		return aliases[normalized] || normalized || 'all';
	}

	function getRequestedCategoryFilter() {
		if (!window.URLSearchParams) return 'all';

		try {
			var params = new URLSearchParams(window.location.search);
			return normalizeEventCategoryFilter(params.get('category'));
		} catch (error) {
			return 'all';
		}
	}

	archives.forEach(function(archive) {
		var cards = Array.prototype.slice.call(archive.querySelectorAll('[data-event-card]'));
		var filterButtons = Array.prototype.slice.call(archive.querySelectorAll('[data-event-filter]'));
		var loadMore = archive.querySelector('[data-events-load-more]');
		var count = archive.querySelector('[data-events-count]');
		var empty = archive.querySelector('[data-events-empty]');
		var clear = archive.querySelector('[data-events-clear]');
		var initialLimit = parseInt(archive.getAttribute('data-initial-limit'), 10) || 12;
		var pageSize = parseInt(archive.getAttribute('data-page-size'), 10) || initialLimit;
		var requestedFilter = archive.getAttribute('data-initial-filter') || getRequestedCategoryFilter();
		var activeFilter = requestedFilter;
		var visibleLimit = initialLimit;

		function setVisible(element, isVisible) {
			element.hidden = !isVisible;
			element.classList.toggle('is-hidden', !isVisible);
		}

		function matchesFilter(card) {
			var categories = (card.getAttribute('data-event-categories') || '').toLowerCase().split(/\s+/);
			if (activeFilter === 'all') return true;
			return categories.indexOf(activeFilter) !== -1;
		}

		// MANE-822: the filter lives in the URL (?category=preschool) so a filtered list can be linked to and shared.
		function syncFilterToUrl() {
			if (!window.history || !window.history.replaceState || !window.URLSearchParams) return;

			try {
				var url = new URL(window.location.href);
				if (activeFilter === 'all') {
					url.searchParams.delete('category');
				} else {
					url.searchParams.set('category', activeFilter);
				}
				window.history.replaceState(null, '', url.pathname + (url.search || '') + (url.hash || ''));
			} catch (error) {
				// Leave the address bar alone if the URL cannot be rewritten.
			}
		}

		function setActiveFilter(nextFilter) {
			activeFilter = normalizeEventCategoryFilter(nextFilter);
			visibleLimit = initialLimit;
			syncFilterToUrl();

			filterButtons.forEach(function(button) {
				var isActive = normalizeEventCategoryFilter(button.getAttribute('data-event-filter')) === activeFilter;
				button.classList.toggle('active', isActive);
				button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});

			render();
		}

		function render() {
			var matched = cards.filter(matchesFilter);
			var visibleCount = Math.min(visibleLimit, matched.length);

			cards.forEach(function(card) {
				setVisible(card, false);
			});

			matched.forEach(function(card, index) {
				setVisible(card, index < visibleLimit);
			});

			if (count) {
				count.textContent = matched.length
					? 'Showing ' + visibleCount + ' of ' + matched.length
					: 'Showing 0 of 0';
			}

			if (empty) {
				setVisible(empty, matched.length === 0);
			}

			if (loadMore) {
				setVisible(loadMore, visibleCount < matched.length);
			}
		}

		filterButtons.forEach(function(button) {
			button.addEventListener('click', function() {
				setActiveFilter(button.getAttribute('data-event-filter') || 'all');
			});
		});

		if (clear) {
			clear.addEventListener('click', function() {
				setActiveFilter('all');
			});
		}

		if (loadMore) {
			loadMore.addEventListener('click', function() {
				visibleLimit += pageSize;
				render();
			});
		}

		setActiveFilter(activeFilter);
	});
}

// ─── BOOT ─────────────────────────────────────────
initializeSiteAlert();
initializeHeaderScroll();
initializeMobileMenu();
initializeHeaderSearch();
initializeStaffGrid();
initializePhotoCollages();
initializeResourcesMenus();
initializeMinistriesScrollers();
initializeCardScrollers();
initializeResourceSeriesAccordions();
initializeEpisodeAccordions();
initializeSermonSharing();
initializeResourceVideoModal();
initializeSharePage();
initializeResourceContentModal();
initializeStoriesArchives();
initializeSermonSeriesArchives();
initializeEventsArchives();

var body = document.body;
if (body && body.dataset.homepageShouldSetReturningCookie === 'true') {
	// Returning = third visit (MANE-694). The persistent cookie holds
	// "count|sessionToken"; the session cookie matching that token tells the
	// server the bump came from THIS session, so it doesn't count yet. One
	// session increments at most once, and the design never flips mid-visit.
	var cookieName = body.dataset.homepageAudienceCookie || 'bayou_home_seen';
	var sessionCookieName = 'bayou_home_session';

	function readCookie(name) {
		var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
		return match ? decodeURIComponent(match[1]) : null;
	}

	var stored = readCookie(cookieName) || '';
	var parts = stored.split('|');
	var count = parseInt(parts[0], 10) || 0;
	var token = parts[1] || null;
	var sessionToken = readCookie(sessionCookieName);

	if (!(token && sessionToken && token === sessionToken)) {
		var newToken = String(Date.now()) + Math.random().toString(36).slice(2, 8);
		setCookie(cookieName, count + 1 + '|' + newToken, 365);
		document.cookie = sessionCookieName + '=' + newToken + '; path=/; SameSite=Lax';
	}
}

// Invitation tools share button (BAY-54). The template puts the message and
// invite graphic on data attributes; nothing series-specific lives here.
// Share sheet with the image attached where supported, text-only share as
// the next step down, clipboard copy on browsers without the Share API.
document.querySelectorAll('[data-invite-share]').forEach(function (button) {
	button.addEventListener('click', async function () {
		var text = button.dataset.shareText || '';
		var imageUrl = button.dataset.shareImage || '';

		if (navigator.share) {
			if (imageUrl && navigator.canShare) {
				try {
					var response = await fetch(imageUrl);
					var blob = await response.blob();
					var file = new File([blob], imageUrl.split('/').pop() || 'invite.jpg', { type: blob.type });
					if (navigator.canShare({ files: [file] })) {
						await navigator.share({ text: text, files: [file] });
						return;
					}
				} catch (err) {
					// fall through to text-only share
				}
			}
			try {
				await navigator.share({ text: text + (imageUrl ? '\n\n' + imageUrl : '') });
			} catch (err) {
				// user dismissed the sheet - nothing to do
			}
			return;
		}

		// Desktop without the Share API: copy the invitation instead.
		try {
			await navigator.clipboard.writeText(text + (imageUrl ? '\n\n' + imageUrl : ''));
			var original = button.textContent;
			button.textContent = 'Copied to Clipboard!';
			setTimeout(function () { button.textContent = original; }, 2500);
		} catch (err) {
			window.location.href = 'sms:?&body=' + encodeURIComponent(text);
		}
	});
});

// PDFs always open in a new tab (MANE-738/795/767 et al.)
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('a[href$=".pdf" i]').forEach(function (a) {
		a.setAttribute('target', '_blank');
		a.setAttribute('rel', 'noopener');
	});
});
